import { render, staticRenderFns } from "./CreateNewUserForm.vue?vue&type=template&id=1d276ade&scoped=true&"
import script from "./CreateNewUserForm.vue?vue&type=script&lang=js&"
export * from "./CreateNewUserForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewUserForm.vue?vue&type=style&index=0&id=1d276ade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d276ade",
  null
  
)

export default component.exports